<template>
  <div class="t-wrap">
    <div class="p-wrap">
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  name: 'ThePageTitle'
} 
</script>
<style scoped lang="scss">
.t-wrap{
  width: 100%;
  height: 240px;
  background-image: url(../../assets/images/expand@2x.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  .p-wrap{
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    h3{
      width: 800px;
      height: 100px;
      font-size: 40px;
      font-family: Roboto-Bold, Roboto;
      font-weight: bold;
      color: #FFFFFF;
      line-height: 50px;
    }
    p{
      font-size: 24px;
      font-family: Roboto-Regular, Roboto;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 60px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/home/ThePageTitle.vue